/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Bachelor19Inputs */

const en__field_enum_csjensblank_bachelor19 = /** @type {(inputs: _Field_Enum_Csjensblank_Bachelor19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor`)
};

const de__field_enum_csjensblank_bachelor19 = /** @type {(inputs: _Field_Enum_Csjensblank_Bachelor19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor`)
};

/**
* | output |
* | --- |
* | "Bachelor" |
*
* @param {_Field_Enum_Csjensblank_Bachelor19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_bachelor19 = /** @type {((inputs?: _Field_Enum_Csjensblank_Bachelor19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Bachelor19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_bachelor19(inputs)
	return de__field_enum_csjensblank_bachelor19(inputs)
});
export { _field_enum_csjensblank_bachelor19 as "_field_enum_CSJENSBLANK_BACHELOR" }